export const SAVE_POLYGON = "polygon/SAVE_POLYGON";
export const SAVE_POLYGON_SUCCESS = "polygon/SAVE_POLYGON_SUCCESS";
export const SAVE_POLYGON_ERROR = "polygon/SAVE_POLYGON_ERROR";

export const UPDATE_POLYGON = "polygon/UPDATE_POLYGON";
export const UPDATE_POLYGON_SUCCESS = "polygon/UPDATE_POLYGON_SUCCESS";
export const UPDATE_POLYGON_ERROR = "polygon/UPDATE_POLYGON_ERROR";

export const DELETE_POLYGON_POINT = "polygon/DELETE_POLYGON_POINT";
